import { revalidarCatalogosAposEscrita } from '@/integracoes/src-next/catalogos/revalidar-apos-escrita'
import { resetarParaEstadoInicial } from 'src/utils/executoras/executoras'

import {
  vuexMapDefaultsMutations,
  vuexMapDefaultsActions,
  vuexMapDefaultsGetters
} from 'src/utils.store'

import { API } from 'src/services'

function fromBackend (company) {
  function formatadorCampoCustomizado ({key, value}) {
    return {
      field: key,
      text: value
    }
  }

  const formatPhone = number => {
    const isVoip = !(/55[0-9]{10,11}/.test(number))
    return {
      number: isVoip ? number : number.slice(2),
      voip: isVoip,
      editing: false
    }
  }
  return {
    id: company.id,
    code: company.code,
    name: company.name,
    visivel: company.active,
    // dateModified: company.dateModified,
    // phonePrefix: company.phonePrefix,
    phone: company.phone.map(formatPhone),
    appearOnRealtime: company.appearOnRealtime,
    ddd: company.ddd,
    empregadores: company.empregadores,
    sincronizarRepp: company.sincronizarComRepp,
    descricaoAFD: company.enderecoQueApareceNoAfd,
    timezoneDoColetor: company.aceitarTimezoneDoColetor,
    active: company.active,
    region: company.region,
    fullRegion: company.fullRegion,
    // routine: company.routine,
    priority: company.priority,
    color: company.color,
    customRules: company.customRules,
    location: company.location,
    distanciaMaximaCercaVirtual: company.distanciaMaximaCercaVirtual,
    // repList: company.repList,
    hasOnCall: company.hasOnCall,
    supervisor: company.supervisor,
    positions: company.positions,
    reserve: company.reserve,
    // approveOverridePermission: company.approveOverridePermission
    logradouro: company.logradouro,
    numero: company.numero,
    complemento: company.complemento,
    bairro: company.bairro,
    cep: company.cep,
    enderecoRetornado: company.logradouro || company.numero || company.complemento || company.bairro || company.cep,
    camposCustomizados: company.camposCustomizados.map(formatadorCampoCustomizado)
  }
}

function toBackEnd (state) {
  const statusDoLocalDeTrabalho = state.active

  function formatadorCampoCustomizado ({field, text}) {
    return {
      key: field,
      value: text
    }
  }

  const formatPhone = ({number, voip}) => {
    const numWithoutMask = number
      .replace('(', '')
      .replace(')', '')
      .replace('-', '')

    if (voip) {
      return numWithoutMask
    }
    return `55${numWithoutMask}`
  }

  return {
    id: state.id,
    code: state.code,
    name: state.name,
    visivel: statusDoLocalDeTrabalho,
    // dateModified: state.dateModified,
    phonePrefix: state.phonePrefix,
    phone: state.phone.map(formatPhone),
    appearOnRealtime: state.appearOnRealtime,
    ddd: state.ddd.selected.id,
    employers: state.empregadores.selected ? state.empregadores.selected.map(i => i.id) : [],
    sincronizarComRepp: state.sincronizarRepp,
    enderecoQueApareceNoAfd: state.descricaoAFD,
    aceitarTimezoneDoColetor: state.timezoneDoColetor,
    active: statusDoLocalDeTrabalho,
    region: state.fullRegion[state.fullRegion.length - 1].id,
    routine: state.routine,
    priority: state.priority,
    color: state.color,
    customRules: state.customRules.selected?.id,
    location: state.location,
    distanciaMaximaCercaVirtual: state.distanciaMaximaCercaVirtual,
    repList: state.repList,
    hasOnCall: state.hasOnCall,
    supervisor: state.supervisor.selected?.id,
    positions: state.positions,
    reserve: state.reserve,
    approveOverridePermission: state.approveOverridePermission,
    logradouro: state.logradouro,
    numero: state.numero,
    complemento: state.complemento,
    bairro: state.bairro,
    cep: state.cep,
    camposCustomizados: state.camposCustomizados.map(formatadorCampoCustomizado)
  }
}

function defaultState () {
  return {
    id: null,
    loading: false,
    code: null,
    name: '',
    visivel: true,
    // dateModified: null,
    // phonePrefix: null,
    phone: [],
    appearOnRealtime: true,
    ddd: {
      selected: null,
      loaded: []
    },
    empregadores: { selected: null, loaded: [] },
    sincronizarRepp: false,
    descricaoAFD: '',
    timezoneDoColetor: false,
    active: true,
    region: null,
    fullRegion: [],
    // routine: null,
    priority: 1,
    color: '#f6',
    customRules: { selected: null },
    location: [],
    distanciaMaximaCercaVirtual: null,
    // repList: null,
    hasOnCall: false,
    supervisor: { selected: null },
    positions: [],
    reserve: false,
    // approveOverridePermission: null,
    logradouro: '',
    numero: '',
    complemento: '',
    bairro: '',
    cep: '',
    infoLogradouroRetornado: true,
    infoNumeroRetornado: true,
    infoComplementoRetornado: true,
    infoBairroRetornado: true,
    infoCepRetornado: true,
    enderecoRetornado: false,
    camposCustomizados: []
  }
}

function possuiTipoComponenteEndereco (componenteEndereco, tipo) {
  return componenteEndereco.types.includes(tipo)
}

function enderecoEhDoBrasil (componentesEndereco) {
  const componentePais = componentesEndereco.find(componenteEndereco => possuiTipoComponenteEndereco(componenteEndereco, 'country'))

  return componentePais?.short_name === 'BR'
}

function cepPossuiOitoDigitos (cep) {
  return cep.replace(/\D/g, '').length === 8
}

const getters = {
  ...vuexMapDefaultsGetters(defaultState())
}

const mutations = {
  ...vuexMapDefaultsMutations(defaultState()),
  resetState (state) {
    resetarParaEstadoInicial(state, defaultState())
  },
  setFromState (state, {commonSupervisors, commonEmployers, ...company}) {
    state.ddd.selected = {id: company.ddd, name: company.ddd}
    state.customRules.selected = company.customRules
    state.supervisor.selected = commonSupervisors.find(s => s.id === company.supervisor)
    state.empregadores.selected = commonEmployers.filter(empregador => {
      const ehArray = Array.isArray(company.empregadores)
      if (ehArray) {
        return company.empregadores.includes(empregador.id)
      } else {
        return false
      }
    })

    delete company.ddd
    delete company.customRules
    delete company.supervisor
    delete company.empregadores
    Object.assign(state, company)
  },
  loading (state, payload) {
    state.loading = payload
  },
  locationVazio (state){
    state.location = [];
  },
  enderecoVazio (state) {
    state.logradouro = ''
    state.numero = ''
    state.complemento = ''
    state.bairro = ''
    state.cep = ''
    state.infoLogradouroRetornado = true
    state.infoNumeroRetornado = true
    state.infoComplementoRetornado = true
    state.infoBairroRetornado = true
    state.infoCepRetornado = true
    state.enderecoRetornado = false
  },
  lugarParaEndereco (state, payload) {
    state.logradouro = ''
    state.numero = ''
    state.complemento = ''
    state.bairro = ''
    state.cep = ''
    state.infoLogradouroRetornado = false
    state.infoNumeroRetornado = false
    state.infoComplementoRetornado = false
    state.infoBairroRetornado = false
    state.infoCepRetornado = false
    state.enderecoRetornado = false

    const ehEnderecoDoBrasil = enderecoEhDoBrasil(payload)

    payload.forEach(componenteEndereco => {
      componenteEndereco.types.forEach(tipo => {
        switch (tipo) {
          case 'route':
            state.logradouro = componenteEndereco['long_name']
            state.infoLogradouroRetornado = true
            state.enderecoRetornado = true
            break
          case 'street_number':
            state.numero = componenteEndereco['long_name']
            state.infoNumeroRetornado = true
            state.enderecoRetornado = true
            break
          case 'sublocality':
            state.bairro = componenteEndereco['long_name']
            state.infoBairroRetornado = true
            state.enderecoRetornado = true
            break
          case 'postal_code':
            if (ehEnderecoDoBrasil && !cepPossuiOitoDigitos(componenteEndereco['long_name'])) {
              break
            }

            state.cep = componenteEndereco['long_name']
            state.infoCepRetornado = true
            state.enderecoRetornado = true
            break
        }
      })
    })
  },
  salvarSincronizarComRepp (state, payload) {
    state.sincronizarRepp = payload
  },
  mudarVisibilidadeDoLocalDeTrabalho (state, status) {
    state.visivel = status
    state.active = status
  },
  sobreAvisoSempreAtivo (state, valor) {
    state.hasOnCall = valor
  }
}

const actions = {
  ...vuexMapDefaultsActions(defaultState()),
  async loadCompany ({ commit, rootState, state, rootGetters, dispatch }, companyId) {
    commit('loading', true)

    await dispatch('common/employers/fetchItems', undefined, { root: true })
    const api = await API.company.get({id: companyId})
    const infoCompleta = api.data.success[0]
    let empregadoresCommon = rootState.common.employers.items
    
    if(rootState.userInfo.compMan.hasInternacionalizacao){
      try {
        empregadoresCommon = rootGetters['common/employers/apenasVisiveis']
      } catch {
        state.empregadores = { selected: null, loaded: [] }
      }
    }
    else if (rootState.userInfo.compMan.portaria671 && infoCompleta.sincronizarComRepp) {
      try {
        empregadoresCommon = rootGetters['common/employers/visiveisComIdRepp']
      } catch {
        state.empregadores = { selected: null, loaded: [] }
      }
    }

    commit('setFromState', {
      id: companyId,
      commonSupervisors: rootState.common.supervisors.items,
      commonEmployers: empregadoresCommon,
      ...fromBackend(infoCompleta)
    })

    commit('loading', false)
  },
  async save ({ state, dispatch }) {
    const info = toBackEnd(state)

    const resposta = state.id
      ? await API.company.save({id: state.id}, info)
      : await API.company.save(info)
    revalidarCatalogosAposEscrita(dispatch, ['companies'])
    return resposta.data.created ?? resposta.data.updated
  }
}

export default {
  namespaced: true,
  state: defaultState(),
  getters,
  mutations,
  actions
}
